import { RouterType } from '@online-webinar/router';
import { ShareWebinar } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/share'].update({
        staticData: { title: { webinar: 'Title.ShareWebinar' } },
        component: authGuard(ShareWebinar, { canBroadcast: true })
    });
};
